import ExecutionEnvironment from 'exenv'

// https://github.com/davidtheclark/no-scroll/blob/master/index.js
export const scrollbarSize = () => {
    if (!ExecutionEnvironment.canUseDOM) {
        return 0
    }

    var doc = document.documentElement
    var dummyScroller = document.createElement('div')
    dummyScroller.setAttribute(
        'style',
        'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;'
    )
    doc.appendChild(dummyScroller)
    const size = dummyScroller.offsetWidth - dummyScroller.clientWidth
    doc.removeChild(dummyScroller)
    return size
}
